import gql from 'graphql-tag';

export const mutationDeleteConversation = gql`
  mutation deleteConversation (
    $id: DokkioID!
  ) {
    deleteConversation (
      id: $id
    )
  }
`;
export default mutationDeleteConversation;
